import styled from 'styled-components'
import { theme } from '../../constants/theme'

const Title = styled.h1`
  text-align: ${({ center }) => center && 'center'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  font-weight: ${({ weight }) => weight};
`

const Heading = styled.h2`
  text-align: ${({ center }) => center && 'center'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  font-weight: ${({ weight }) => weight};
`

const SubHeading = styled.h3`
  text-align: ${({ center }) => center && 'center'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  font-weight: ${({ weight }) => weight};
`

const SmallHeading = styled.h4`
  text-align: ${({ center }) => center && 'center'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
`

const Paragraph = styled.p`
  font-weight: ${({ weight }) => weight};
  font-size: ${({ size }) => size};
  line-height: ${({ lineHeight }) => lineHeight};
  text-align: ${({ center }) => center && 'center'};
  margin: ${({ margin }) => margin || '0'};
  color: ${({ color }) => color};
`

const HeadingTertiary = styled.h3`
  margin-bottom: 16px;
  color: ${({ green }) => (green ? theme.colors.fonts.green : 'white')};
`

export { Title, Heading, SubHeading, SmallHeading, Paragraph, HeadingTertiary }
